import { MatchListCommon, MatchListStoreModel } from '../../utils/match-list-models';
import { AppAction, SimpleMap } from '@om-fe/store';
import { FAVORITE_EVENTS_TOPIC } from '@om-fe/core/components/favorite-button/favorite-state.store';
import { AggregatorOneOfTypeModel, AggregatorTournamentsModel, DisciplineLiveStatus, ModelTypes } from '@om-fe/models';
import { MatchListItemLayout } from "../../utils/match-list.constants";
import { BreakpointsState } from '@om-fe/core/core/store/breakpoints';

export const FAVORITE_MATCH_AGGREGATOR_PATH: string = 'user-favorite-events-aggregator/:userID/:nrOfMarkets/:liveStatus';

export const favoriteSlicePrefix: string = 'favorite';

export interface FavoriteMatchListTopic {
    readonly path: string;
    readonly params: {
        readonly userID: number;
        readonly nrOfMarkets: number;
        readonly liveStatus: DisciplineLiveStatus;
    };
}

export interface FavoriteMatchListDisciplinesTopic {
    readonly path: string;
    readonly params: {
        readonly userID: number;
        readonly nrOfMarkets: number;
        readonly liveStatus: DisciplineLiveStatus;
        readonly disciplineId: string;
    };
}

export interface FavoriteMatchListStoreModel {
    readonly ready: boolean;
    readonly liveStatus: DisciplineLiveStatus;
    readonly isLoadingMoreData: boolean;
    readonly isLoadingData: boolean;
    readonly filteredSportIds: string[];
    readonly isDefault?: boolean;
    readonly userID: number;
    readonly mainMarketsLimit?: number;
    readonly mappedDisciplineSet: Record<ModelTypes, Record<string, AggregatorOneOfTypeModel>> | undefined;
    readonly disciplines: Record<string, FavoriteMatchListDisciplineItemStoreModel>;
}

export interface FavoriteMatchListDisciplineItemStoreModel extends MatchListStoreModel {
    readonly isLoadingMoreData: boolean;
    readonly isLoadingData: boolean;
}

export interface FavoriteMatchListDefaultProps {
    readonly hasHeader: boolean;
}

export interface FavoriteMatchListPublicProps extends Omit<MatchListCommon, 'locationId' | 'eventCategoryId' | 'limitNumberOfEvents'> {
    readonly userID: number;
    readonly isDefault?: boolean;
    readonly isLoadingData?: boolean;
    readonly itemLayout?: MatchListItemLayout;
}

export interface FavoriteMatchListStoreProps {
    readonly sliceKey: string;
    readonly ready: boolean;
    readonly filteredSportIds?: string[];
    readonly isAuthenticated: boolean;
    readonly favoriteMatchIds?: string[];
    readonly breakpoints: BreakpointsState;
}

export enum FavoriteMatchListActionsTypes {
    SetLoadingData = 'sports:live-match-list:set-loading-data',
    SetFilterData = 'sports:live-match-list:set-match-list-filter-data',
}

export interface FavoriteMatchListSetLoadingData extends AppAction<FavoriteMatchListActionsTypes.SetLoadingData> {
    readonly meta: {
        readonly slice: string;
    };
    readonly payload: {
        readonly isLoadingMoreData: boolean;
    };
}

export interface FavoriteMatchListSetFilterDataAction extends AppAction<FavoriteMatchListActionsTypes.SetFilterData> {
    readonly meta: {
        readonly slice: string;
    };
    readonly payload: {
        readonly userID: number;
        readonly mainMarketsLimit?: number;
        readonly liveStatus: DisciplineLiveStatus;
        readonly isDefault?: boolean;
    };
}

export interface FavoritesTournamentsTopicParams {
    readonly topic: string;
    readonly params: SimpleMap;
}

export type FavoritesAggregatorOneOfTypeModel = AggregatorOneOfTypeModel | AggregatorTournamentsModel;

export function getFavoritesTournamentsTopicParams(
    userID: number,
): FavoritesTournamentsTopicParams {
    return { topic: FAVORITE_EVENTS_TOPIC, params: { userID } };
}
